/*
 * @Author: ttheitao
 * @Date: 2024-03-29 10:34:03
 * @Description: some description
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-07-31 17:29:21
 */
import axios, { AxiosRequestHeaders } from 'axios';

/**
 * 创建axios实例
 */
const instance = axios.create({
  // baseURL: `http://dwh.test:8089/api`,
  baseURL: `https://dwh_api.bimcc.net/api`,
  timeout: 60000,
});

/**
 * 请求拦截
 */
instance.interceptors.request.use(
  (config) => {
    if (!config.headers) {
      config.headers = {} as AxiosRequestHeaders;
    }
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }

    const token = localStorage.getItem("onetab_token") ?? '';

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (err) => {
    //console.log(err);
    return Promise.reject(err);
  }
);

/**
 * 响应拦截
 */
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (err) {
    //console.log(err);
    return Promise.reject(err);
  }
);

export default instance;
